export default {
    articles: 'Articles',
    resource: 'Article',

    id: 'ID',
    title: 'Title',
    seo_title: 'SEO Title',
    lead: 'Lead',
    slug: 'Slug',
    body: 'Body',
    is_active: 'Active',
    is_draft: 'Draft',
    is_sponsored: 'Sponsored',
    is_18_plus: 'over 18',
    published_at: 'Published',
    image: 'Image',

    tags: 'Tags',
    authors: 'Authors',
    categories: 'Categories',

    delete: 'Delete',
    created_at: 'Created',
    updated_at: 'Updated',

    sort_by: 'Sort by',
    'sortby.published_date_oldest': 'Published date oldest',
    'sortby.published_date_newest': 'Published date newest',
    'sortby.created_date_oldest': 'Created date oldest',
    'sortby.created_date_newest': 'Created date oldest',
};
